/**
 * Numbered list - max width
 */
for (const el of document.querySelectorAll('.col-md-4.offset-md-1, .col-md-6, .col-6, .col-lg-6, .col-xl-6')) {
    for (const list of el.querySelectorAll('.ce_numbered-list')) {
        list.classList.add('set-max-width')
    }
}
